import { render, staticRenderFns } from "./disc.vue?vue&type=template&id=525ec2f8&scoped=true"
import script from "./disc.vue?vue&type=script&lang=js"
export * from "./disc.vue?vue&type=script&lang=js"
import style0 from "./disc.vue?vue&type=style&index=0&id=525ec2f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ec2f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525ec2f8')) {
      api.createRecord('525ec2f8', component.options)
    } else {
      api.reload('525ec2f8', component.options)
    }
    module.hot.accept("./disc.vue?vue&type=template&id=525ec2f8&scoped=true", function () {
      api.rerender('525ec2f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/device/disc.vue"
export default component.exports